import React, { Component, Fragment } from "react";
import Modal from "../Modal";
import OtpSmsIcon from "../../Resources/Icons/OtpSmsIcon";
import OtpInput from "react-otp-input";
import Button from "../../Resources/Forms/Button";
import withAppData from "../../HOC/withAppData";
import { GET, POST } from "../../Utils/api";
import { idempotencyKey } from "../../Utils/helpers";
import dayjs from "dayjs";
import "../../Styles/Pages/deliveryotp.scss";
import QrReader from "react-qr-reader";

let todayDate;
class DeliveryOtp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			otp: "",
			loading: false,
			otpVerified: false,
			activeVerificationOption: this.props.activeVerificationOption || 1,
			otpPhone: "",
			isDriver: ["reseller biker", "reseller van driver"].includes(
				this.props.context.role.toLowerCase(),
			),
			isAddOrderFlashVerification: false,
			flashNumber: "013434001",
			qrScannerStep: 1,
			QRVerified: false,
			qrError: false,
			otpTimer: "00:00:30",
			isResendOtp: false,
			seconds: 0,
		};
	}

	componentDidMount() {
		this.setState(
			{
				otpPhone: this.props.retailerPhoneNumber
					? this.props.retailerPhoneNumber
					: this.props.order.CustomerPhone,
			},
			() => {
				if (!this.props.otpVerifyConfirm) this.sendOtp();
				this.generateUssdOtp();
			},
		);
	}

	componentWillMount() {
		if (this.state.activeVerificationOption === 5) {
			this.verifyPin();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.otp !== this.state.otp) {
			if (this.state.otp && this.state.otp.toString().length === 4) {
				this.verifyOtp();
			}
		}
		if (
			prevState.activeVerificationOption !== this.state.activeVerificationOption
		) {
			this.setState({ otp: "" });
		}
	}
	handleScan = async data => {
		if (data) {
			if (this.props.otpVerifyConfirm) {
				const formData = new FormData();
				formData.append("orderId", this.props.deliveredFormData.orderId);
				formData.append(
					"orderStatusId",
					this.props.deliveredFormData.orderStatusId,
				);
				formData.append("file", this.props.deliveredFormData.file);
				formData.append("otp", 0);
				formData.append("type", 2);
				formData.append("qrCodeDecoded", data);
				const {
					AmountCollectedByDriver,
					OrderAmount,
				} = this.props.deliveredData;
				if ((AmountCollectedByDriver || 0) < OrderAmount) {
					const idempotency =
						this.props.deliveredFormData.orderId + idempotencyKey();
					formData.append("idempotencyKey", idempotency);
				}
				let response = await POST(this.props.otpVerifyConfirm, formData);
				if (!response.error) {
					this.props.successOtpVerify();
				} else {
					console.log("response.error.message", response.error.message);
					if (response.error.message === "An error occured. Please try again") {
						this.props.context.showAlert("Error paying with QRCode", "error");
						this.setState({ qrScannerStep: 1, qrError: true, loading: false });
					}
				}
			}
		}
	};

	render() {
		return (
			<div className="delivery-otp">
				<Modal
					closeModal={this.props.close}
					header={"Acknowledge Order"}
					width={"550px"}
					isSmall={true}
					// preventClose={!!this.props.context.isSettingsActivated(28)}
				>
					<div className="delivery-otp-tab flex">
						<div
							className={
								this.state.activeVerificationOption === 5 ? "active" : ""
							}
							onClick={() => {
								this.state.activeVerificationOption === 5 &&
									this.setState({
										activeVerificationOption: 5,
										qrScannerStep: 1,
										QRVerified: false,
									});
							}}
							style={{
								width:
									this.state.isDriver && this.props.sourceId === 16
										? "100%"
										: "50%",
							}}
						>
							<span>
								<svg
									stroke={
										this.state.activeVerificationOption === 5
											? "#015fd1"
											: "currentColor"
									}
									fill={
										this.state.activeVerificationOption === 5
											? "#015fd1"
											: "currentColor"
									}
									strokeWidth="0"
									viewBox="0 0 1024 1024"
									height="1em"
									width="1em"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"></path>
								</svg>
							</span>
							PIN
						</div>
						<div
							className={
								this.state.activeVerificationOption === 1 ? "active" : ""
							}
							onClick={() =>
								this.state.activeVerificationOption !== 5 &&
								this.setState({
									activeVerificationOption: 1,
									qrScannerStep: 1,
									QRVerified: false,
								})
							}
							style={{
								width:
									this.state.isDriver && this.props.sourceId === 16
										? "100%"
										: "50%",
							}}
						>
							<span>
								<svg
									stroke={
										this.state.activeVerificationOption === 1
											? "#015fd1"
											: "currentColor"
									}
									fill={
										this.state.activeVerificationOption === 1
											? "#015fd1"
											: "currentColor"
									}
									strokeWidth="0"
									viewBox="0 0 1024 1024"
									height="1em"
									width="1em"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"></path>
								</svg>
							</span>
							OTP
						</div>
						{this.state.isDriver ? (
							this.props.sourceId !== 16 ? (
								<div
									className={
										this.state.activeVerificationOption === 3 ? "active" : ""
									}
									onClick={() =>
										this.state.activeVerificationOption === 3 &&
										this.addOrderFlashVerification()
									}
								>
									<span>
										<svg
											stroke={
												this.state.activeVerificationOption === 3
													? "#015fd1"
													: "currentColor"
											}
											fill={
												this.state.activeVerificationOption === 3
													? "#015fd1"
													: "currentColor"
											}
											strokeWidth="0"
											viewBox="0 0 1024 1024"
											height="1em"
											width="1em"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path d="M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"></path>
										</svg>
									</span>
									Flash Delivery
								</div>
							) : null
						) : (
							<div
								className={
									this.state.activeVerificationOption === 2 ? "active" : ""
								}
								onClick={() =>
									this.state.activeVerificationOption === 2 &&
									this.setState({
										activeVerificationOption: 2,
										qrScannerStep: 1,
										QRVerified: false,
									})
								}
							>
								<span>
									<svg
										stroke={
											this.state.activeVerificationOption === 2
												? "#015fd1"
												: "currentColor"
										}
										fill={
											this.state.activeVerificationOption === 2
												? "#015fd1"
												: "currentColor"
										}
										strokeWidth="0"
										viewBox="0 0 1024 1024"
										height="1em"
										width="1em"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path d="M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"></path>
									</svg>
								</span>
								Ussd
							</div>
						)}
						<div
							className={
								this.state.activeVerificationOption === 4 ? "active" : ""
							}
							onClick={() =>
								this.props.deliveredData &&
								this.props.deliveredData.AmountCollectedByDriver >=
									this.props.deliveredData.OrderAmount &&
								this.state.activeVerificationOption !== 5 &&
								this.setState({
									activeVerificationOption: 4,
									qrScannerStep: 1,
									QRVerified: false,
								})
							}
						>
							<span>
								<svg
									stroke={
										this.state.activeVerificationOption === 4
											? "#015fd1"
											: "currentColor"
									}
									fill={
										this.state.activeVerificationOption === 4
											? "#015fd1"
											: "currentColor"
									}
									strokeWidth="0"
									viewBox="0 0 1024 1024"
									height="1em"
									width="1em"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path d="M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"></path>
								</svg>
							</span>
							QR Code Delivery
						</div>
					</div>
					<div style={{ minHeight: "100px" }}>
						{this.state.activeVerificationOption === 1 ? (
							<Fragment>
								<div className="delivery__otp__image">
									<OtpSmsIcon color={"#015fd1"} />
								</div>
								<div className="delivery-otp-text">
									Please enter the OTP code that was sent to{" "}
									<b>{this.state.otpPhone}</b>
								</div>
							</Fragment>
						) : this.state.activeVerificationOption === 3 ? (
							<Fragment>
								<div className="delivery-otp-text">
									Please provide this phone number to the customer and ask them
									to flash this number
								</div>
								<div className="delivery__otp__image">
									<OtpSmsIcon color={"#015fd1"} />
								</div>
								<div className="delivery-otp-text">
									<b>{this.state.flashNumber}</b>
									<br />
									Note that the call will be cut automatically after 2 rings and
									the customer will not be charged any airtime for this.'
								</div>
							</Fragment>
						) : this.state.activeVerificationOption === 5 ? (
							<Fragment>
								<div className="delivery-otp-pin">
									<div className="delivery-otp-pin-loader"></div>
									<div className="delivery-otp-pin-text">
										<p>Awaiting PIN Entry</p>
										<p>Please wait as Retailer inputs PIN.</p>
									</div>
									{/* <div className="delivery-otp-pin-timer">
                                        <img src="" alt="timer" />
                                        <span>00.21</span>
                                    </div> */}
								</div>
								{/* <div className="delivery__otp__image">
                                    <OtpSmsIcon color={"#015fd1"} />
                                </div>
                                <div className="delivery-otp-text">
                                    <b>{this.state.flashNumber}</b>
                                    <br />
                                    Note that the call will be cut automatically after 2 rings and
                                    the customer will not be charged any airtime for this.'
                                </div> */}
							</Fragment>
						) : this.state.activeVerificationOption === 4 ? (
							<>
								{this.state.qrScannerStep === 1 ? (
									<>
										<div className="relative">
											<div className="delivery-otp-text">
												Click below to scan the QR Code and verify the retailer
											</div>
											<div className="delivery__otp__image">
												<OtpSmsIcon color={"#015fd1"} />
											</div>
											<label
												className="default-qr"
												htmlFor={"default-qr"}
												style={{
													border: this.state.qrError ? "1px solid red" : "",
												}}
												onClick={() => {
													this.setState({ qrScannerStep: 2 });
												}}
											>
												<div className="delivery-otp-text">
													<img src="Images/camera.svg" alt="" />
													{this.state.qrError ? (
														<>Rescan QR Code</>
													) : (
														<>Scan QR Code</>
													)}
												</div>
											</label>
										</div>
									</>
								) : this.state.qrScannerStep === 2 ? (
									<>
										<div className="delivery__otp__image">
											<QrReader
												delay={300}
												onError={() => {
													this.setState({ qrScannerStep: 1 });
												}}
												onScan={this.handleScan}
												style={{ width: "80%", height: "300px" }}
											/>
										</div>
									</>
								) : this.state.qrScannerStep === 3 ? (
									<div className="default-qr">
										<label className="default-qr" htmlFor={"default-qr"}>
											<div className="delivery-otp-text">
												<img src="Images/tick-green.svg" alt="" />
												Successfully Verified QR Code
											</div>
										</label>
									</div>
								) : (
									<></>
								)}
							</>
						) : (
							<Fragment>
								<div
									onClick={() =>
										(window.location.href = `tel:*347*221*${this.state.encryptedOtp}*${this.props.order.CustomerPhone}*2%23`)
									}
								>
									<h2>
										<img
											src="Images/dark-call.svg"
											alt=""
											className="hide--desktop"
										/>
										<span className="hide--desktop">Get Otp Code</span>
										<div className="show--desktop">
											*347*221*{this.state.encryptedOtp}*{this.state.otpPhone}
											*2#
										</div>
									</h2>
									<div className="light center">
										<span className="show--desktop">
											Tap the code above and enter the 4 digit Otp code sent to
											the customer
										</span>
										<span className="hide--desktop">
											Enter the 4 digit Otp code sent to the customer
										</span>
									</div>
								</div>
							</Fragment>
						)}
						{this.state.activeVerificationOption !== 3 &&
							this.state.activeVerificationOption !== 5 &&
							this.state.activeVerificationOption !== 4 && (
								<div className="delivery-otp-input">
									<OtpInput
										onChange={otp => this.setState({ otp })}
										numInputs={4}
										inputStyle={"form__input"}
										isInputNum={true}
										separator={<span> </span>}
										value={this.state.otp}
										errorStyle="form__input__error"
									/>
								</div>
							)}
					</div>

					{this.state.activeVerificationOption !== 3 &&
						this.state.activeVerificationOption !== 5 &&
						this.state.activeVerificationOption !== 4 && (
							<div className="delivery-otp-skip">
								<span
									className="center primary smaller"
									onClick={() => this.resendOtp()}
								>
									{this.state.isResendOtp && this.state.seconds > 0
										? `00: ${
												this.state.seconds < 10
													? `0` + this.state.seconds
													: this.state.seconds
										  }`
										: `Resend otp`}
								</span>
							</div>
						)}
					<div className="delivery-otp-skip">
						{/* {!this.props.context.isSettingsActivated(28) && (
                            <span
                                className="center primary smaller"
                                onClick={() => this.skipVerification()}
                            >
                                Skip
                            </span>
                        )} */}
					</div>
					{this.state.activeVerificationOption !== 5 && (
						<div className="modal-submit">
							<Button
								text={
									this.state.activeVerificationOption === 4
										? "Deliver using QR Code"
										: this.state.activeVerificationOption !== 3
										? "Verify Otp"
										: "Verify Order"
								}
								noMargin={true}
								disabled={
									this.state.activeVerificationOption !== 3 &&
									this.state.otp.toString().length < 4 &&
									this.state.QRVerified === false
								}
								onClick={() =>
									this.state.activeVerificationOption === 4
										? this.qrCodeDelivery()
										: this.state.activeVerificationOption === 3
										? this.verifyFlash()
										: this.verifyOtp()
								}
								loading={this.state.loading}
								type={"primary"}
							/>
						</div>
					)}
				</Modal>
			</div>
		);
	}

	generateUssdOtp = () => {
		todayDate = parseInt(dayjs().format("DDMM"));
		const otp = Math.floor(Math.random() * (9999 - todayDate)) + todayDate;
		const tempOtp = otp - todayDate;
		this.setState({ encryptedOtp: tempOtp }, () => {});
	};

	verifyUssdCode = async () => {
		await this.setState({ loading: true });
		const tempOtp = this.state.encryptedOtp;
		if (tempOtp + todayDate === Number(this.state.otp)) {
			let response = await POST("addressbook/verifyUserOtp", {
				VerificationType: 3,
				Phone: this.state.otpPhone,
				OTP: this.state.otp,
			});
			if (response.error) {
				this.props.context.showAlert(response.error.message, "error");
				this.setState({ loading: false });
			} else {
				//this.props.context.showAlert("Delivery acknowledged successfully");
				this.props.successOtpVerify();
			}
		} else {
			setTimeout(() => {
				this.setState({ loading: false });
				this.props.context.showAlert("Incorrect OTP", "error");
			}, 5000);
		}
	};

	verifyPin = async () => {
		await this.setState({ loading: true });
		// let data = {
		// 	OrderId: this.props.order.Orderid,
		// 	Customerid: this.props.order.Customerid,
		// 	Phone: this.state.otpPhone,
		// 	Otp: this.state.otp,
		// 	retailerName:
		// 		this.props.retailerStoreName || this.props.order.CustomerName || "",
		// 	source: this.props.source || "",
		// 	Type: "PIN",
		// };
		var attempts = 1;
		const myInterval = setInterval(function () {
			startPin();
		}, 5000);
		const startPin = async () => {
			if (!this.props.showOtpView) {
				clearInterval(myInterval);
			}
			if (attempts < 20) {
				//code goes here that will be run every 5 seconds.
				let response = await GET(
					`OmniPay/RetriveOmnipayPaymentBreakdownOMS?orderId=${this.props.order.Orderid}`,
				);
				if (response.IsPaid === 1) {
					const data = {
						NewStage: "Delivered",
						Pipelineid: this.props.order.Pipelineid,
						Note: "From Delivery",
						CreatedBy: Number(this.props.context.userId),
					};
					POST("pipeline/Updatepipeline", data)
						.then(response => {})
						.catch(error => {
							setTimeout(() => {}, 2500);
						});

					clearInterval(myInterval);
					attempts = 20;
					//this.props.context.showAlert("Delivery acknowledged successfully");
					this.props.successOtpVerify(data);
					// this.props.history.push({
					// 	pathname: "/oms-shipments",
					// });
				} else {
					attempts += 1;
				}
			} else {
				clearInterval(myInterval);
				// this.props.history.push({
				// 	pathname: "/oms-shipments",
				// });
				window.location.reload();
				// this.props.close(true);
			}
		};
	};

	resendOtp = async () => {
		if (this.state.loading) {
			return;
		}
		await this.setState({ loading: true, isResendOtp: true, seconds: 30 });
		this.handleTimer();
		let response = await POST(
			`OmniPay/ResendOrderPaymentOTP?orderId=${this.props.order.Orderid}`,
		);
		if (response.error) {
			this.props.context.showAlert(
				"unable to resend otp, please try again",
				"error",
			);
			this.setState({ loading: false, isResendOtp: false });
		} else {
			return;
		}
	};

	verifyOtp = async () => {
		if (this.state.loading) {
			return;
		}
		if (this.state.activeVerificationOption === 2) {
			this.verifyUssdCode();
			return;
		}
		// this.setState({isClickedVerifyMOTP: true})
		await this.setState({ loading: true });
		if (this.props.otpVerifyConfirm) {
			const formData = new FormData();
			formData.append("orderId", this.props.deliveredFormData.orderId);
			formData.append(
				"orderStatusId",
				this.props.deliveredFormData.orderStatusId || 0,
			);
			formData.append("file", this.props.deliveredFormData.file);
			formData.append("otp", this.state.otp);
			const { AmountCollectedByDriver, OrderAmount } = this.props.deliveredData;
			
			if ((AmountCollectedByDriver || 0) < OrderAmount) {
				const idempotency =
					this.props.deliveredFormData.orderId + idempotencyKey();
				formData.append("idempotencyKey", idempotency);
			}
			let response = await POST(this.props.otpVerifyConfirm, formData);
			if (response.error) {
				this.props.context.showAlert("Wrong OTP Provided", "error");
				this.setState({ loading: false });
			} else {
				const data = {
					NewStage: "Delivered",
					Pipelineid: this.props.order.Pipelineid,
					Note: "From Delivery",
					CreatedBy: Number(this.props.context.userId),
				};

				// POST("pipeline/Updatepipeline", data)
				// 	.then(response => {})
				// 	.catch(error => {
				// 		setTimeout(() => {
				// 			console.log("error", error);
				// 		}, 2500);
				// 	});
				//this.props.context.showAlert("Delivery acknowledged successfully");
				this.props.successOtpVerify(data);
			}
		} else {
			let data = {
				OrderId: this.props.order.Orderid,
				Customerid: this.props.order.Customerid,
				Phone: this.state.otpPhone,
				Otp: this.state.otp,
				retailerName:
					this.props.retailerStoreName || this.props.order.CustomerName || "",
				source: this.props.source || "",
				Type: "OTP",
			};
			let response = await POST("store/GetVerifyCustomerAcknowledgement", data);
			if (response.error) {
				this.props.context.showAlert(response.error.message, "error");
				this.setState({ loading: false });
			} else {
				//this.props.context.showAlert("Delivery acknowledged successfully");
				// const data = {
				// 	NewStage: "RTO",
				// 	Pipelineid: this.props.order.Pipelineid,
				// 	Note: "From RTO",
				// 	CreatedBy: Number(this.props.context.userId),
				// };
				// POST("pipeline/Updatepipeline", data)
				// 	.then(response => {})
				// 	.catch(error => {
				// 		setTimeout(() => {
				// 			console.log("error", error);
				// 		}, 2500);
				// 	});
				this.props.successOtpVerify(data);
			}
		}
	};

	qrCodeDelivery = () => {
		let data = {
			OrderId: this.props.order.Orderid,
			Customerid: this.props.order.Customerid,
			Phone: this.state.otpPhone,
			retailerName:
				this.props.retailerStoreName || this.props.order.CustomerName || "",
			source: this.props.source || "",
			Type: "QR Code",
		};
		this.props.successOtpVerify(data);
	};

	addOrderFlashVerification = async () => {
		this.setState({ qrScannerStep: 1 });
		if (this.state.loading) {
			return;
		}
		if (this.state.isAddOrderFlashVerification) {
			this.setState({ activeVerificationOption: 3 });
			return;
		}
		await this.setState({ loading: true });
		let data = {
			orderId: this.props.order.Orderid,
			orderStatusId: this.props.sourceId,
			phone: this.state.otpPhone,
		};
		let response = await POST(
			"OrderManagement/AddOrderFlashVerification",
			data,
		);
		if (!response.error) {
			this.setState({
				activeVerificationOption: 3,
				loading: false,
				isAddOrderFlashVerification: true,
			});
		}
	};

	handleTimer = () => {
		let interval = setInterval(() => {
			if (this.state.seconds > 0) {
				this.setState({ seconds: this.state.seconds - 1 });
			} else {
				this.setState({ loading: false, isResendOtp: false });
				this.props.context.showAlert("Otp successfully sent", "success");
				clearInterval(interval);
			}
		}, 1000);
	};

	initQRCodeVerification = () => {
		if (this.state.loading) {
			return;
		}
	};

	verifyFlash = async () => {
		if (this.state.loading) {
			return;
		}
		if (this.state.activeVerificationOption === 2) {
			this.verifyUssdCode();
			return;
		}
		await this.setState({ loading: true });
		let response = await GET(
			`OrderManagement/GetOrderFlashVerification?orderId=${this.props.order.Orderid}&phone=${this.state.otpPhone}`,
		);
		if (response.error) {
			this.props.context.showAlert(response.error.type.message, "error");
			this.setState({ loading: false });
		} else {
			let data = {
				OrderId: this.props.order.Orderid,
				Customerid: this.props.order.Customerid,
				Phone: this.state.otpPhone,
				retailerName:
					this.props.retailerStoreName || this.props.order.CustomerName || "",
				source: this.props.source || "",
				Type: "Flash",
			};
			this.props.successOtpVerify(data);
		}
	};

	sendOtp() {
		let data = {
			OrderId: this.props.order.Orderid,
			Customerid: this.props.order.Customerid,
			Phone: this.state.otpPhone,
			source: this.props.source || "",
		};
		POST("store/AddCustomerAcknowledgement", data);
	}

	skipVerification = () => {
		if (this.state.loading) {
			return;
		}
		this.props.context.showAlert("Order status changed successfully");
		this.props.close();
	};
}

export default withAppData(DeliveryOtp);
